import gql from 'graphql-tag';

export const CreateDatabaseMutation = gql`
	mutation CreateDatabaseMutation($spaceKey: String!, $parentId: ID) {
		createContentContextual(
			input: { parentId: $parentId, spaceKey: $spaceKey, status: CURRENT, type: "database" }
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
